import {pageInfo, initPage, rePush, rePushBatch} from './../api';
import {selectCarrier, listInterfaceCode} from '../../../../api'
import { Message } from 'element-ui';
const interfaceLog = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    addResp: null,
    editResp: null,
    deleteResp: null,
    initPageObj: null,
    initUpdateObj: null,
    rePushObj: null,
    rePushBatchObj: null,
    carrierObj:null,
    interfaceCodeObj:null
  },
  mutations: {

    PAGE_INFO(state,data){
      state.total = data.total;
      // state.pageResp = data.obj || [];
      // state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [ item.dealStatus == '99'] }));
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [ true] }));
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    CARRIER_INFO_DATA(state,data){
      state.carrierInfoObj = data.obj || [];
    },
    REPUSH(state,data){
      state.rePushObj = data;
    },
    REPUSHBATCH(state,data){
      state.rePushBatchObj = data;
    },
    SELECT_CARRIER(state, resp){
      state.carrierObj = resp.obj || [];
    },
    INTERFACE_CODE_DATA(state, resp){
      state.interfaceCodeObj = resp.obj || [];
    },

  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //rePush
    async rePush({ commit }, obj) {
      let resp = await rePush(obj);
      commit('REPUSH', resp);
    },
    //rePushBatch
    async rePushBatch({ commit }, obj) {
      let resp = await rePushBatch(obj);
      commit('REPUSHBATCH', resp);
    },
    //物流商
    async ListCarrierSelect({ commit }, obj) {
      let resp = await selectCarrier(obj);
      commit('SELECT_CARRIER', resp);
    },
    //接口方代码
    async listInterfaceCode({ commit }, obj) {
      let resp = await listInterfaceCode(obj);
      commit('INTERFACE_CODE_DATA', resp);
    },
  }
}
export default interfaceLog



// WEBPACK FOOTER //
// ./src/page/log/interfaceLog/store/interfaceLog.store.js